import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import RowNoData from '@/components/elements/RowNoData';
import Subtitulo from '@/components/elements/Subtitulo';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import { Alerta } from '@/objects/Alertas';
import RowAlerta from '@/components/elements/listas/lista_alertas/RowAlerta';
import Boton from '@/components/elements/Boton';
import { gray, primary, white } from '@/constants/Colors';
import TextFieldCustom, { AutocompleteValues, InputTypes } from '@/components/elements/TextFieldCustom';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { mostrarAlerta } from '@/context/UtilsContext';
import { useNotificationContext } from '@/context/NotificationContext';
import Texto from '@/components/elements/Texto';

function AlertasLibros() {

    const { alertasQueries } = useServices();
    const { userData } = useNotificationContext();

    const [alertasActuales, setAlertasActuales] = React.useState<Alerta[]>([]);

    //Para añadir alerta:
    const [tituloAlerta, setTituloAlerta] = React.useState<string>("");
    const [autorAlerta, setAutorAlerta] = React.useState<string>("");
    const [editorialAlerta, setEditorialAlerta] = React.useState<string>("");
    const [isbnAlerta, setIsbnAlerta] = React.useState<string>("");

    const { t } = useTranslation();

    useEffect(() => {
        cargarAlertas();
    }, []);

    const cargarAlertas = () => {
        alertasQueries?.obtenerAlertasUsuario().then((response: AxiosResponse<Alerta[]>) => {
            if (response.status == 200) {
                setAlertasActuales(response.data);
            }
        }
        ).catch((error: any) => {

        });
    }

    const agregarAlerta = () => {
        if (tituloAlerta.trim() === "" && autorAlerta.trim() === "" && editorialAlerta.trim() === "" && isbnAlerta.trim() === "") {
            mostrarAlerta({
                title: t('common:opciones.error'),
                content: t('menu:secciones.alertas.introduce_uno_de_los_atributos_de_la_alerta'),
                showCancelButton: false,
            });
            return;
        }
        const alerta: Alerta = {
            id_user: userData?.id_user!,
            titulo_libro: tituloAlerta.trim() !== "" ? tituloAlerta.trim() : undefined,
            autor: autorAlerta.trim() !== "" ? autorAlerta.trim() : undefined,
            editorial: editorialAlerta.trim() !== "" ? editorialAlerta.trim() : undefined,
            isbn: isbnAlerta.trim() !== "" ? isbnAlerta.trim() : undefined,
        }
        alertasQueries?.establecerAlerta(alerta).then((response: AxiosResponse<number>) => {
            if (response.status == 201) {
                setTituloAlerta("");
                setAutorAlerta("");
                setEditorialAlerta("");
                setIsbnAlerta("");
                cargarAlertas();
            }
        });
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%', alignContent: "center", alignItems: "center" }}>
            <TituloPrincipalH1 texto={t("menu:secciones.alertas.titulo")} />
            <Subtitulo texto={t("menu:secciones.alertas.descripcion")} />
            <div style={{ marginTop: "20px" }}>
                <Texto fontSize={"18px"} color={primary}>{t("menu:secciones.alertas.para_crear_una_alerta")}</Texto>
                <TextFieldCustom id="titulo_alerta" label={t('contenido:subir-libro.titulo_libro')}
                    value={tituloAlerta}
                    setValue={setTituloAlerta}
                    required={false} autocomplete={AutocompleteValues.Off} inputType={InputTypes.Search}
                    leftIcon={<LibraryBooksIcon />} />
                <TextFieldCustom id="isbn_alerta" label={t('contenido:libro.datos.isbn')}
                    value={isbnAlerta}
                    setValue={setIsbnAlerta}
                    required={false} autocomplete={AutocompleteValues.Off} inputType={InputTypes.Search}
                    leftIcon={<LibraryBooksIcon />} />
                <TextFieldCustom id="autor_alerta" label={t('contenido:subir-libro.autor')}
                    value={autorAlerta}
                    setValue={setAutorAlerta}
                    required={false} autocomplete={AutocompleteValues.Off} inputType={InputTypes.Search}
                    leftIcon={<LibraryBooksIcon />} />
                <TextFieldCustom id="editorial_alerta" label={t('contenido:subir-libro.editorial')}
                    value={editorialAlerta}
                    setValue={setEditorialAlerta}
                    required={false} autocomplete={AutocompleteValues.Off} inputType={InputTypes.Search}
                    leftIcon={<LibraryBooksIcon />} />
            </div>
            <div style={{ marginLeft: "10px" }}>
                <Boton color={primary} colorTexto={white} startIcon={<AddAlertIcon />} texto={t("menu:secciones.alertas.add_alerta")} onClick={() => { agregarAlerta() }} />
            </div>
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', width: "100%", marginTop: "20px" }}>
                    <Texto fontSize={"18px"} color={primary}>{t("menu:secciones.alertas.lista_de_alertas")}</Texto>
                    <Texto fontSize={"12px"} color={gray}>{t("menu:secciones.alertas.si_las_alertas_no_funcionan")}</Texto>
                </div>

                {alertasActuales.length > 0 ? alertasActuales.map((alerta: Alerta, index: number) => {
                    return (
                        <section style={{ display: 'flex', flexDirection: 'column', width: "100%", margin: "10px", alignItems: "center" }} key={index}>
                            <RowAlerta alerta={alerta} onCargar={cargarAlertas} />
                        </section>
                    );
                }) : <RowNoData texto={t("menu:secciones.alertas.no_hay_alertas")} />}
            </section>
        </section>
    );
}

export default AlertasLibros;